function adjustElementHeights() {
    const screenWidth = window.innerWidth;
    const title1 = document.querySelector('.variux-box-2-col.mobile_view .variux-box-2-col-content .col-first.container .promobox__text_item_title');
    const title2 = document.querySelector('.variux-box-2-col.mobile_view .variux-box-2-col-content .col-second.container .promobox__text_item_title');
    const para1 = document.querySelector('.variux-box-2-col.mobile_view .variux-box-2-col-content .col-first.container .promobox__text_item_description .contect-des');
    const para2 = document.querySelector('.variux-box-2-col.mobile_view .variux-box-2-col-content .col-second.container .promobox__text_item_description .contect-des');
    if (screenWidth >= 769 && screenWidth <= 1180) {
        const heightTitle1 = title1.offsetHeight;
        const heightTitle2 = title2.offsetHeight;
        const heightPara1 = para1.offsetHeight;
        const heightPara2 = para2.offsetHeight;


        const maxHeightTitle = Math.max(heightTitle1, heightTitle2);
        const maxHeightPara = Math.max(heightPara1, heightPara2);

        if (heightTitle1 < maxHeightTitle) {
            title1.style.minHeight = `${maxHeightTitle}px`;
        } else if (heightTitle2 < maxHeightTitle) {
            title2.style.minHeight = `${maxHeightTitle}px`;
        }

        if (heightPara1 < maxHeightPara) {
            para1.style.minHeight = `${maxHeightPara}px`;
        } else if (heightPara2 < maxHeightPara) {
            para2.style.minHeight = `${maxHeightPara}px`;
        }
    } else {
        if (title1 != null) {
            title1.style.minHeight = '';
        }
        if (title2 != null) {
            title2.style.minHeight = '';
        }
        if (para1 != null) {
            para1.style.minHeight = '';
        }
        if (para2 != null) {
            para2.style.minHeight = '';
        }
    }
}
adjustElementHeights();
window.addEventListener('resize', adjustElementHeights);
window.addEventListener('load', adjustElementHeights);
